/*
 *
 * Header constants
 *
 */

export const DEFAULT_ACTION = 'app/Header/DEFAULT_ACTION';

export const DROPDOWN_OPTIONS_WITH_SEARCH_OPTIONS = [
  {
    key: 1,
    value: 'EST - Eastern Standard Time',
    time: '(UTC +5:30)',
  },
  {
    key: 2,
    value: 'PST - Pacific Standard Time',
    time: '(UTC +5:30)',
  },
  {
    key: 3,
    value: 'IST - Indian Standard Time',
    time: '(UTC +5:30)',
  },
  {
    key: 4,
    value: 'GMT - Greenwich Mean Time',
    time: '(UTC +5:30)',
  },
  {
    key: 5,
    value: 'CET - Central European Time',
    time: '(UTC +5:30)',
  },
];

export const TIMEZONE_MAPPER = {
  'PST - Pacific Standard Time': 'PST',
  'IST - Indian Standard Time': 'IST',
  'CET - Central European Time': 'CET',
  'GMT - Greenwich Mean Time': 'GMT',
  'EST - Eastern Standard Time': 'EST',
};

export const TIMEZONE_MAPPED_LABELS = {
  PST: 'PST - Pacific Standard Time',
  IST: 'IST - Indian Standard Time',
  CET: 'CET - Central European Time',
  GMT: 'GMT - Greenwich Mean Time',
  EST: 'EST - Eastern Standard Time',
};

export const TIMEZONE_INFO_CONTENT =
  'This change will only impact the times displayed on your dashboard. Reporting exports, API/Webhook responses, and settlement times will continue to follow Indian Standard Time (IST)';
